<template>
  <div style="overflow-y:none">
    <div class="top-box whiteBg">
      <search-input
        :placeholder="'请输入要搜索的服务网点名称'"
        @search="handleSearch"
      ></search-input>
    </div>
    <div>
      <!-- <van-tabs v-model="active" sticky>
        <van-tab title="全部">
          <site-details
            :nowList="nowList"
            :cilentHeight="cilentHeight"
          ></site-details>
        </van-tab>
        <van-tab title="快递柜">
          <site-details
            :nowList="nowList"
            :active="active"
            :cilentHeight="cilentHeight"
          ></site-details>
        </van-tab>
        <van-tab title="驿站">
          <site-details
            :nowList="nowList"
            :active="active"
            :cilentHeight="cilentHeight"
          ></site-details>
        </van-tab>
      </van-tabs> -->
      <site-details
        :cilentHeight="cilentHeight"
        ref="siteDetail"
      ></site-details>
    </div>
  </div>
</template>
<script>
import searchInput from '@/components/search'
import siteDetails from './components/siteDetails'
export default {
  data() {
    return {
      active: 0,
      cilentHeight: 0
    }
  },
  components: {
    searchInput,
    siteDetails
  },
  mounted() {
    this.cilentHeight = document.documentElement.clientHeight
  },
  methods: {
    handleSearch(key) {
      this.$refs.siteDetail.handleSearch(key)
      // console.log(this.$refs)
    }
  }
}
</script>
<style lang="scss" scoped>
.top-box {
  padding: 0 10px 10px;
  overflow: hidden;
}
</style>
